import React, {useEffect, useState} from 'react';
import { apiBaseUrl } from "../Globals";
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { getCurrentUser } from '../auth';

const Login = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [user, setUser] = useState('');

    useEffect(() => {
        const fetchUser = async () => {
            setUser(getCurrentUser());
        };
        fetchUser();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        try {

            const formData = new FormData();
            formData.append("email", email);
            formData.append("password", password);

            const response = await fetch(apiBaseUrl + '?tx_biathlonhub_api[action]=login', {
                method: 'POST',
                body: formData,
            });

            const data = await response.json();

            if (!data.success) {
                setError(data.message || t('user.login.loginFailed'));
                return false;
            }

            if (data.user) {
                // ✅ Save the user data to localStorage
                localStorage.setItem('biathlonhubUser', JSON.stringify(data.user));

                // ✅ Navigate to home/dashboard
                navigate('/');
            } else {
                setError(t('user.login.loginFailed'));
            }
        } catch (err) {
            setError(t('user.login.loginFailedUnexpectedError'));
        }
    };

    if (user) {
        return (
            <div className="p-4 flex flex-col h-full">
                <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 mb-4">
                    {t('user.login.headline')}
                </h1>

                <div className="mx-auto max-w-[48rem] w-full">
                    {t('user.login.youAreAlreadyLoggedIn')}
                </div>
            </div>
        );
    }

    return (
        <div className="p-4 flex flex-col h-full">
            <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 mb-4">
                {t('user.login.headline')}
            </h1>

            <div className="mx-auto max-w-[48rem] w-full">
                <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                    {error && <div className="text-red-500 font-bold">{error}</div>}

                    <div className="flex flex-col gap-y-6 gap-x-2 md:flex-row md:items-end">
                        <div className="flex flex-col gap-2 md:grow">
                            <label htmlFor="email" className="font-bold">{t('user.login.email')}</label>
                            <div className="form-input-wrap">
                                <input
                                    id="email"
                                    type="email"
                                    value={email}
                                    placeholder={t('user.login.email')}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-2  md:grow">
                            <label htmlFor="password" className="font-bold">{t('user.login.password')}</label>
                            <div className="form-input-wrap">
                                <input
                                    id="password"
                                    type="password"
                                    value={password}
                                    placeholder={t('user.login.password')}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    <div className="px-2">
                        <button type="submit" className="button-primary">
                            {t('user.login.login')}
                        </button>
                    </div>

                    <div className="text-sm">
                        {t('user.login.dontHaveAnAcc')} <Link to="/registration" className="underline">{t('user.login.register')}</Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
